import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Profile, School, StudentClass, Student } from '@df/interfaces';
import { PeopleService } from '@app/core/services/';
import { HandlerService } from '@app/_services/handler.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-parent-profile-settings',
    templateUrl: './parent-profile-settings.component.html',
    styleUrls: ['./parent-profile-settings.component.scss']
})
export class ParentProfileSettingsComponent implements OnInit {
    profile: Profile;
    schools: Array<School>;
    classes: Array<StudentClass>;
    students: Array<Student>;
    choosedStudents: Array<Student> = [];
    form: FormGroup;
    displayedColumns: string[] = ['full_name', 'actions'];
    dataSource: any = new MatTableDataSource();
    parentChildren: Array<Student>;

    constructor(
        private peopleServices: PeopleService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private handlerServices: HandlerService
    ) {}

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.profile = data['profile'].data;
            this.getParentChilds();
        });
        this.form = this.fb.group({
            school: ['', []],
            class: ['', []],
            student: ['', []]
        });

        this.getSchools();
    }

    private getSchools(): void {
        this.peopleServices.getSchools().subscribe(resp => {
            this.schools = resp.results;
        });
    }

    getSchoolClasses(): void {
        const schoolId = this.form.value.school;
        this.peopleServices.getSchoolClasses(schoolId).subscribe(resp => {
            this.classes = resp.data;
        });
    }

    getClassStudents(): void {
        const studentClassId = this.form.value.class;
        this.peopleServices.getStudents(studentClassId).subscribe(resp => {
            this.students = resp.data;
        });
    }

    getParentChilds(): void {
        const userId = this.profile.user.id;
        this.peopleServices.getParentChildren(userId).subscribe(resp => {
            this.handlerServices.checkErrors(resp);
            this.parentChildren = resp.data;
            this.dataSource = new MatTableDataSource(this.parentChildren);
            // console.log(this.parentChildren, this.profile);
        });
    }

    finishSelector(): void {
        const student = this.form.value.student;

        this.choosedStudents = this.choosedStudents.filter(item => {
            return item.id !== student.id;
        });
        this.choosedStudents.push(student);
        this.dataSource = new MatTableDataSource(this.choosedStudents);
        this.form.patchValue({
            school: '',
            class: '',
            student: ''
        });

        this.classes = [];
        this.students = [];
    }

    deleteStudent(student: Student): void {
        this.choosedStudents = this.choosedStudents.filter(item => {
            return item.id !== student.id;
        });
        this.dataSource = new MatTableDataSource(this.choosedStudents);
    }

    saveParentChild(): void {}
}
